// src/data/refs.js - NOMENCLATURE EXCEL
export const refs = {
  refEpreuve: [
    { code: "SM", labelFr: "Simple Messieurs" , labelEn: "Single Men" },
    { code: "SD", labelFr: "Simple Dames"     , labelEn: "Single Women" }
    ],
  refClassement: [
    { code: "1", labelFr: "Non classé"        , labelEn: "Unranked" },
    { code: "4", labelFr: "40/2"              , labelEn: "40/2" },
    { code: "8", labelFr: "40/1"              , labelEn: "40/1" },
    { code: "12", labelFr: "40"               , labelEn: "40" },
    { code: "16", labelFr: "30/5"             , labelEn: "30/5" },
    { code: "20", labelFr: "30/4"             , labelEn: "30/4" },
    { code: "24", labelFr: "30/3"             , labelEn: "30/3" },
    { code: "28", labelFr: "30/2"             , labelEn: "30/2" },
    { code: "32", labelFr: "30/1"             , labelEn: "30/1" },
    { code: "36", labelFr: "30"               , labelEn: "30" },
    { code: "40", labelFr: "15/5"             , labelEn: "15/5" },
    { code: "44", labelFr: "15/4"             , labelEn: "15/4" },
    { code: "48", labelFr: "15/3"             , labelEn: "15/3" },
    { code: "52", labelFr: "15/2"             , labelEn: "15/2" },
    { code: "56", labelFr: "15/1"             , labelEn: "15/1" },
    { code: "60", labelFr: "15"               , labelEn: "15" },
    { code: "64", labelFr: "5/6"              , labelEn: "5/6" },
    { code: "68", labelFr: "4/6"              , labelEn: "4/6" },
    { code: "72", labelFr: "3/6"              , labelEn: "3/6" },
    { code: "76", labelFr: "2/6"              , labelEn: "2/6" },
    { code: "80", labelFr: "1/6"              , labelEn: "1/6" },
    { code: "84", labelFr: "0"                , labelEn: "0" },
    { code: "88", labelFr: "-2/6"             , labelEn: "-2/6" },
    { code: "92", labelFr: "-4/6"             , labelEn: "-4/6" },
    { code: "96", labelFr: "-15"              , labelEn: "-15" },
    { code: "100", labelFr: "Top 100 Hommes France"  , labelEn: "Top Men 100 France" },
    { code: "102", labelFr: "Top 60 Femmes France"   , labelEn: "Top 60 Women France" },
    { code: "103", labelFr: "Top 60 Hommes France"   , labelEn: "Top 60 Men France" },
    { code: "104", labelFr: "Top 40 Femmes France"   , labelEn: "Top 40 Women France" },
    { code: "105", labelFr: "Top 30 Hommes France"   , labelEn: "Top 30 Men France" },
    { code: "106", labelFr: "Top 20 Femmes France"   , labelEn: "Top 20 Women France" },
    { code: "112", labelFr: "Top 1000 ATP"    , labelEn: "Top 1000 ATP" },
    { code: "116", labelFr: "Top 900 ATP"     , labelEn: "Top 900 ATP" },
    { code: "122", labelFr: "Top 800 ATP"     , labelEn: "Top 800 ATP" },
    { code: "126", labelFr: "Top 700 ATP"     , labelEn: "Top 700 ATP" },
    { code: "130", labelFr: "Top 600 ATP"     , labelEn: "Top 600 ATP" },
    { code: "134", labelFr: "Top 500 ATP"     , labelEn: "Top 500 ATP" },
    { code: "138", labelFr: "Top 400 ATP"     , labelEn: "Top 400 ATP" },
    { code: "142", labelFr: "Top 300 ATP"     , labelEn: "Top 300 ATP" },
    { code: "146", labelFr: "Top 200 ATP"     , labelEn: "Top 200 ATP" },
    { code: "150", labelFr: "Top 100 ATP"     , labelEn: "Top 100 ATP" },
    { code: "154", labelFr: "Top 50 ATP"      , labelEn: "Top 50 ATP" },
    { code: "158", labelFr: "Top 20 ATP"      , labelEn: "Top 20 ATP" },
    { code: "162", labelFr: "Top 10 ATP"      , labelEn: "Top 10 ATP" }
  ],
  refSurface: [
    { code: "DI", labelFr: "Dur intérieur"  , labelEn: "Hard indoor" },
    { code: "DE", labelFr: "Dur extérieur"  , labelEn: "Hard outdoor" },
    { code: "TI", labelFr: "Terre intérieur", labelEn: "Clay indoor" },
    { code: "TE", labelFr: "Terre extérieur", labelEn: "Clay outdoor" },
    { code: "GE", labelFr: "Gazon extérieur", labelEn: "Green outdoor" }
  ],
  refCategorie: [
    { code: "1", labelFr: "Tournoi amateur"     , labelEn: "Non pro tournament" },
    { code: "2", labelFr: "TMC"                 , labelEn: "TMC" },
    { code: "3", labelFr: "Champ. départemental", labelEn: "Departmental Champ." },
    { code: "4", labelFr: "Champ. régional"     , labelEn: "Regional Champ." },
    { code: "5", labelFr: "Champ. national"     , labelEn: "National Champ." },
    { code: "6", labelFr: "Champ. équipe dép."  , labelEn: "Dep. Team Champ." },
    { code: "7", labelFr: "Champ. équipe rég."  , labelEn: "Reg. Team Champ." },
    { code: "8", labelFr: "Champ. équipe nat."  , labelEn: "Nat. Team Champ." },
    { code: "9", labelFr: "Entrainement"        , labelEn: "Training " },
    { code: "10", labelFr: "Grand Chelem"       , labelEn: "Grand Slam " },
    { code: "11", labelFr: "ATP Finales"        , labelEn: "ATP Finals" },
    { code: "12", labelFr: "Masters 1000"       , labelEn: "Masters 1000" },
    { code: "13", labelFr: "ATP-WTA 500"        , labelEn: "ATP-WTA 500" },
    { code: "14", labelFr: "ATP-WTA 250"        , labelEn: "ATP-WTA 250" },
    { code: "15", labelFr: "ATP-WTA 125"        , labelEn: "ATP-WTA 125" },
    { code: "16", labelFr: "ATP-WTA 75"         , labelEn: "ATP-WTA 75" },
    { code: "17", labelFr: "ATP-WTA 50"         , labelEn: "ATP-WTA 50" },
    { code: "18", labelFr: "ATP-WTA 25"         , labelEn: "ATP-WTA 25" },
    { code: "19", labelFr: "Coupe Davies"       , labelEn: "Davies Cup" },
    { code: "20", labelFr: "Fed Cup"            , labelEn: "Fed Cup" },
    { code: "21", labelFr: "Laver Cup"          , labelEn: "Laver Cup" },
    { code: "22", labelFr: "Challenger"         , labelEn: "Challenger" },
    { code: "23", labelFr: "ITF"                , labelEn: "ITF" }
  ],
  refPays: [
    { code: "FRA", labelFr: "France"    , labelEn: "France" },
    { code: "BEL", labelFr: "Belgique"  , labelEn: "Belgium" },
    { code: "DEM", labelFr: "Allemagne" , labelEn: "Germany" },
    { code: "CHE", labelFr: "Suisse"    , labelEn: "Swiss" },
    { code: "GBR", labelFr: "Angleterre", labelEn: "England" },
    { code: "ESP", labelFr: "Espagne"   , labelEn: "Spain" },
    { code: "ITA", labelFr: "Italie"    , labelEn: "Italy" },
    { code: "POR", labelFr: "Portugal"  , labelEn: "Portugal" },
    { code: "GRE", labelFr: "Grèce"     , labelEn: "Greece" },
    { code: "USA", labelFr: "Etats-Unis", labelEn: "United States" },
    { code: "CAN", labelFr: "Canada"    , labelEn: "Canada" },
    { code: "AUS", labelFr: "Australie" , labelEn: "Australia" }
  ],
  refTour: [
    { code: "Q1", labelFr: "1er tour qualif"  , labelEn: "1st qualif. round" },
    { code: "Q2", labelFr: "2nd tour qualif"  , labelEn: "2nd qualif. round" },
    { code: "Q3", labelFr: "3ème tour qualif" , labelEn: "3rd qualif. round" },
    { code: "T1", labelFr: "1er tour"         , labelEn: "1st round" },
    { code: "T2", labelFr: "2nd tour"         , labelEn: "2nd round" },
    { code: "T3", labelFr: "3ème tour"        , labelEn: "3rd round" },
    { code: "T4", labelFr: "4ème tour"        , labelEn: "4th round" },
    { code: "T5", labelFr: "5ème tour"        , labelEn: "5th round" },
    { code: "V6", labelFr: "1/8 de finale"    , labelEn: "round of 16" },
    { code: "V7", labelFr: "1/4 de finale"    , labelEn: "Quarter-final" },
    { code: "V8", labelFr: "1/2 de finale"    , labelEn: "Semi-final" },
    { code: "V9", labelFr: "Finale"           , labelEn: "Final" }
  ],
  refCategorieAge: [
    { code: "U10", labelFr: "Moins de 10 ans" , labelEn: "U10" },
    { code: "U11", labelFr: "Moins de 11 ans" , labelEn: "U11" },
    { code: "U12", labelFr: "Moins de 12 ans" , labelEn: "U12" },
    { code: "U13", labelFr: "Moins de 13 ans" , labelEn: "U13" },
    { code: "U14", labelFr: "Moins de 14 ans" , labelEn: "U14" },
    { code: "U15", labelFr: "Moins de 15 ans" , labelEn: "U15" },
    { code: "U16", labelFr: "Moins de 16 ans" , labelEn: "U16" },
    { code: "U17", labelFr: "Moins de 17 ans" , labelEn: "U17" },
    { code: "U18", labelFr: "Moins de 18 ans" , labelEn: "U18" },
    { code: "SEN", labelFr: "Sénior"          , labelEn: "Senior" },
    { code: "S35", labelFr: "Plus de 35 ans"  , labelEn: "V35" },
    { code: "S45", labelFr: "Plus de 45 ans"  , labelEn: "V45" },
    { code: "S55", labelFr: "Plus de 55 ans"  , labelEn: "V55" },
    { code: "S65", labelFr: "Plus de 65 ans"  , labelEn: "V65" },
    { code: "S75", labelFr: "Plus de 75 ans"  , labelEn: "V75" }
  ]
};

// FAMILLE DE COUP (RefFamille)
export const refFamille = [
  { code: "S", labelFr: "Service",    labelEn: "Serve" },
  { code: "T", labelFr: "Retour",     labelEn: "Return" },
  { code: "C", labelFr: "Coup droit", labelEn: "Forehand" },
  { code: "R", labelFr: "Revers",     labelEn: "Backhand" },
  { code: "V", labelFr: "Volée",      labelEn: "Volley" },
  { code: "?", labelFr: "???",          labelEn: "???" },  // 🆕 Point libre (hors stats)
];

// Sous Types (RefSousType)
export const refSousType = {
  // Service
  S: [
    { code: "1", labelFr: "Ext égalité"   , labelEn: "Wide deuce"     , labelLongFr: "extérieur côté égalité" , labelLongEn: "wide on deuce side"},
    { code: "2", labelFr: "Corps égalité" , labelEn: "Body deuce"     , labelLongFr: "au corps côté égalité"  , labelLongEn: "body on deuce side"},
    { code: "3", labelFr: "T égalité"     , labelEn: "T deuce"        , labelLongFr: "au T côté égalité"      , labelLongEn: "at T on deuce side"},
    { code: "4", labelFr: "T avantage"    , labelEn: "T advantage"    , labelLongFr: "au T côté avantage"     , labelLongEn: "at T on advantage side"},
    { code: "5", labelFr: "Corps avantage", labelEn: "Body advantage" , labelLongFr: "au corps côté avantage" , labelLongEn: "body on advantage side"},
    { code: "6", labelFr: "Ext avantage"  , labelEn: "Wide advantage" , labelLongFr: "extérieur côté avantage", labelLongEn: "wide on advantage side"},
  ],
  
  // Retour (identique au service)
  T: [
    { code: "1", labelFr: "Ext égalité"   , labelEn: "Wide deuce"     , labelLongFr: "extérieur côté égalité" , labelLongEn: "wide on deuce side"},
    { code: "2", labelFr: "Corps égalité" , labelEn: "Body deuce"     , labelLongFr: "au corps côté égalité"  , labelLongEn: "body on deuce side"},
    { code: "3", labelFr: "T égalité"     , labelEn: "T deuce"        , labelLongFr: "au T côté égalité"      , labelLongEn: "at T on deuce side"},
    { code: "4", labelFr: "T avantage"    , labelEn: "T advantage"    , labelLongFr: "au T côté avantage"     , labelLongEn: "at T on advantage side"},
    { code: "5", labelFr: "Corps avantage", labelEn: "Body advantage" , labelLongFr: "au corps côté avantage" , labelLongEn: "body on advantage side"},
    { code: "6", labelFr: "Ext avantage"  , labelEn: "Wide advantage" , labelLongFr: "extérieur côté avantage", labelLongEn: "wide on advantage side"},
  ],
  
  // Coup droit
  C: [
    { code: "C", labelFr: "Croisé"        , labelEn: "Cross"          , labelLongFr: "croisé"                   , labelLongEn: "crosscourt"},
    { code: "E", labelFr: "Au centre"     , labelEn: "Middle"         , labelLongFr: "au centre"                , labelLongEn: "down the middle"},
    { code: "L", labelFr: "Long de ligne" , labelEn: "Down the line"  , labelLongFr: "long de ligne"            , labelLongEn: "down the line"},
    { code: "P", labelFr: "Passing/Lob"   , labelEn: "Passing/Lob"    , labelLongFr: "de passing / lob"         , labelLongEn: "passing shot / lob" },
    { code: "O", labelFr: "Inside out"    , labelEn: "Inside out"     , labelLongFr: "de décalage croisé"       , labelLongEn: "inside out" },
    { code: "M", labelFr: "Inside middle" , labelEn: "Inside middle"  , labelLongFr: "de décalage au centre"    , labelLongEn: "inside middle"},
    { code: "I", labelFr: "Inside in"     , labelEn: "Inside in"      , labelLongFr: "de décalage long de ligne", labelLongEn: "inside in" },
    { code: "A", labelFr: "Amorti"        , labelEn: "Drop shot"      , labelLongFr: "amorti"                   , labelLongEn: "drop shot"},
  ],
  
  // Revers
  R: [
    { code: "C", labelFr: "Croisé"        , labelEn: "Cross"          , labelLongFr: "croisé"           , labelLongEn: "crosscourt"},
    { code: "E", labelFr: "Au centre"     , labelEn: "Middle"         , labelLongFr: "au centre"        , labelLongEn: "down the middle"},
    { code: "L", labelFr: "Long de ligne" , labelEn: "Down the line"  , labelLongFr: "long de ligne"    , labelLongEn: "down the line"},
    { code: "P", labelFr: "Passing/Lob"   , labelEn: "Passing/Lob"    , labelLongFr: "de passing / lob", labelLongEn: "passing shot / lob"},
    { code: "A", labelFr: "Amorti"        , labelEn: "Drop shot"      , labelLongFr: "amorti"           , labelLongEn: "drop shot"},
    { code: "S", labelFr: "Slice"         , labelEn: "Slice"          , labelLongFr: "slicé"            , labelLongEn: "sliced" },
  ],
  
  // Volée
  V: [
    { code: "C", labelFr: "Coup droit", labelEn: "Forehand volley"  , labelLongFr: "de coup droit", labelLongEn: "forehand volley"},
    { code: "R", labelFr: "Revers"    , labelEn: "Backhand volley"  , labelLongFr: "de revers"    , labelLongEn: "backhand volley"},
    { code: "A", labelFr: "Amortie"   , labelEn: "Drop volley"      , labelLongFr: "amortie"      , labelLongEn: "drop volley"},
    { code: "S", labelFr: "Smash"     , labelEn: "Smash"            , labelLongFr: "smashée"      , labelLongEn: "smash"},
  ],

  // 🆕 Point libre - pas de sous-type
  "?": [],
};

// NB FRAPPES (RefNbFrappesCode)
export const refNbFrappes = [
  { code: 3, labelFr: "3 à 4  " ,  labelEn: "3 to 4"  , labelLongFr: "dans un échange entre 3 et 4 frappes", labelLongEn: "in a 3 to 4 shot rally"},
  { code: 5, labelFr: "5 à 8"   ,  labelEn: "5 to 8"  , labelLongFr: "dans un échange entre 5 et 8 frappes", labelLongEn: "in a 5 to 8 shot rally"},
  { code: 9, labelFr: "9 et +"  ,  labelEn: "9 & +"   , labelLongFr: "dans un échange de plus de 9 frappes", labelLongEn: "in a rally of more than 9 shots"},
];

// RÉSULTAT POINT (Point / Faute)
export const refResultat = [
  { code: ""  , labelFr: "Point" , labelEn: "Point" },
  { code: "F" , labelFr: "Faute" , labelEn: "Error" },
];

// EFFET (RefEffet)
export const refEffet = [
  { code: "P", labelFr: "Plat"  , labelEn: "Flat" },
  { code: "S", labelFr: "Slicé" , labelEn: "Slice" },
  { code: "L", labelFr: "Lifté" , labelEn: "Topspin" },
];

// FAUTE DIRECTE (RefFauteDirecte)
export const refFauteDirecte = [
  { code: "F", labelFr: "Filet"   , labelEn: "Net"      , labelLongFr: "dans le filet"  , labelLongEn: "into the net"},
  { code: "C", labelFr: "Couloir" , labelEn: "Out wide" , labelLongFr: "dans le couloir", labelLongEn: "wide"},
  { code: "L", labelFr: "Long."   , labelEn: "Long"     , labelLongFr: "en longueur"    , labelLongEn: "long"},
];

// FORMAT SET (RefFormatSet)
export const refFormatSet = [
  { code: "NON"     , labelFr: "Non"                      , labelEn: "No" },
  { code: "STD"     , labelFr: "Standard Tie-break 7 pts" , labelEn: "Standard Tie-break 7 pts" },
  { code: "T10"     , labelFr: "Standard Tie-break 10 pts", labelEn: "Standard Tie-break 10 pts" },
  { code: "S10"     , labelFr: "Super Tie-break 10 pts"   , labelEn: "Super Tie-break 10 pts" },
  { code: "NOAD"    , labelFr: "No avantage + TB 7 pts"   , labelEn: "No advantage + TB 7 pts" },
  { code: "NOADT10" , labelFr: "No avantage + TB 10 pts"  , labelEn: "No advantage + TB 10 pts" },
];

// Services (ajoute dans refs.js)
export const refServiceReussite = [
  { code: "1" , labelFr: "Serv 1", labelEn: "Serv 1" },
  { code: "2" , labelFr: "Serv 2", labelEn: "Serv 2" },
  { code: "SF", labelFr: "Double", labelEn: "Double" },
];

// Zone (ajoute dans refs.js)  
export const refZone = [
  { code: "1", labelFr: "1-Ext" , labelEn: "1-Wide" },
  { code: "2", labelFr: "2-Crps", labelEn: "2-Body" },
  { code: "3", labelFr: "3 - T" , labelEn: "3-T" },
  { code: "4", labelFr: "4 - T" , labelEn: "4-T" },
  { code: "5", labelFr: "5-Crps", labelEn: "5-Body" },
  { code: "6", labelFr: "6-Ext" , labelEn: "6-Wide" },
];